
const role = {
  namespaced: true, 
  state: {
    currentDetail: {},
    detailPdata: {},
    dkeys: [],
    treeList: []
  },
  mutations: {
    SET_DETAIL: (state, data) => {
      state.currentDetail = data
    },
    SET_PDATA: (state, data) => {
      state.detailPdata = data
    },
    SET_DKEYS: (state, data) => {
      state.dkeys = data
    },
    SET_TREE_LIST: (state, data) => {
      state.treeList = data
    }
  },
  actions: {
    setDetail({ commit }, data) {
      commit('SET_DETAIL', data)
    },
    setPdata({ commit }, data) {
      commit('SET_PDATA', data)
    },
    setDkeys({ commit }, data) {
      commit('SET_DKEYS', data)
    },
    setTreeList({ commit }, data) {
      commit('SET_TREE_LIST', data)
    }
  }
}

export default role
